import Colors from '../../theme/Colors';

const styles = {
  root: {
    height: '100%',
    // display: 'flex',
    // flexDirection: 'row',
    width: 'auto',
    padding: 16,
    boxSizing: 'border-box'
  },
  textContainer: {
  },
  iconContainer: {
    marginLeft: 4
  },
  icon: {
    color: Colors.grey
  }
}

export default styles;
